export default __webpack_public_path__ + "static/media/1.5ecda3ad.png";